import { Dialog } from '@/components/UI'

type Props = {
  opened: boolean
  onClose: () => void
}

/**
 * 抽選結果「はずれ」ダイアログ。
 * Figma: node 553-18796（REWORD-抽選-はずれ）
 */
export function DialogV2LotteryLose({ opened, onClose }: Props) {
  return (
    <Dialog selectorState={opened} closeFunc={onClose} title="抽選結果" compact>
      <div className="flex flex-col items-center gap-4 px-4 py-6">
        <div className="h-[185px] w-full overflow-hidden rounded-[8px]">
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_URL}/lottery_lost.png`}
            alt="はずれ"
            className="size-full object-cover"
          />
        </div>
        <p className="text-center text-[16px] font-bold leading-[24px] text-black">はずれ</p>
        <button
          type="button"
          className="flex h-[48px] w-[123px] items-center justify-center rounded-[32px] bg-[#eee] text-[15px] font-bold text-[#757575]"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </Dialog>
  )
}
